import api from '../api';

/**
 * Uploads a file to temporary storage.
 * POST /api/temp-upload { file }
 * Returns: { data: { id, file_url, original_filename, file_size, mime_type } }
 */
const tempUploadService = {
    upload: (file) => {
        const fd = new FormData();
        fd.append('file', file);
        return api.post('/temp-upload', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};

export default tempUploadService;
